module.exports = __webpack_public_path__ + "img/pr-25.4aeb6cd8.png";